import { firestore } from '@/firebaseConfig'
import BookingConfiguration from '../model/BookingConfiguration';

export default class BookingService {

    loadReservotronBookingConfigurationsForPublisher(publisherId) {
        return new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("bookingConfigurations").doc("reservotron").get().then((doc) => {
                if (doc.exists) {
                    resolve(new BookingConfiguration(doc.data()));
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    saveReservotronBookingConfigurationForPublisher(publisherId, bookingConfiguration) {
        if (!bookingConfiguration.id) {
            bookingConfiguration.id = "reservotron";
        }

        console.log(bookingConfiguration.toJSON());

        return firestore.collection("publishers").doc(publisherId).collection("bookingConfigurations").doc("reservotron").set(bookingConfiguration.toJSON());
    }
}